import React from "react";
import { FiArrowRight } from "react-icons/fi";
import Button from "../common/Button";

const HomeHero = () => (
  <section className="site-container home-hero" aria-labelledby="home-hero-title">
    <img
      className="home-hero__image"
      src="/images/home/hero-spice-pantry.jpg"
      alt="Unlabeled glass jars and bowls filled with colorful spices"
      width="1677"
      height="944"
      fetchpriority="high"
    />
    <div className="home-hero__shade" />
    <div className="home-hero__content">
      <p className="eyebrow eyebrow--light">500 flavors. One curious pantry.</p>
      <h1 id="home-hero-title">Remarkable spices, mapped to the way you cook.</h1>
      <p>
        Bright harvests, small-batch blends, and hard-to-find ingredients—packed
        fresh with practical notes for your next meal.
      </p>
      <div className="home-hero__actions">
        <Button to="/shop" size="large">
          Shop the pantry <FiArrowRight aria-hidden="true" />
        </Button>
      </div>
    </div>
  </section>
);

export default HomeHero;
